// Or from '@reduxjs/toolkit/query/react'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { GetOrCreateUserDataStorageItemForLoggedInCustomerAndReturnTheItem, UpdateUserDataStorageItem } from "Util/Api";

// Define a service using a base URL and expected endpoints
export const userDataStorageApi = createApi({
  reducerPath: 'userDataStorageApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: ['RiskAnalisysAndActionYears'],
  endpoints: (builder) => ({
    getRiskAnalisysAndActionYearsForLoggedInCustomer: builder.query({
      queryFn: async () => {
        const riskAnalisysAndActionYearsFromDB = await GetOrCreateUserDataStorageItemForLoggedInCustomerAndReturnTheItem();

        return { data: riskAnalisysAndActionYearsFromDB };
      },
      //Set tag that will be invalidated
      providesTags: ( result ) =>
        // is result available?
        result
          ? // successful query
            [
              { type: 'RiskAnalisysAndActionYears', id: 'CUDS' },
            ]
          : // an error occurred, but we still want to refetch this query when `{ type: 'RiskAnalisysAndActionYears', id: 'CUDS' }` is invalidated
            [
              { type: 'RiskAnalisysAndActionYears', id: 'CUDS' }
            ],
    }),
    updateRiskAnalisysAndActionYearsForLoggedInCustomer: builder.mutation({
      queryFn: async (
        riskAnalisysAndActionYears, api, extraOptions, baseQuery
      ) => {
        //Update DB.
        const result = await UpdateUserDataStorageItem(riskAnalisysAndActionYears);

        return { data: result };
      },
      // Pick out data and prevent nested properties in a hook or selector
      transformResponse: (response, meta, arg) => response.data,
      // Pick out errors and prevent nested properties in a hook or selector
      transformErrorResponse: (response, meta, arg) => response.status,
      invalidatesTags: [{ type: 'RiskAnalisysAndActionYears', id: 'CUDS' }],
      // onQueryStarted is useful for optimistic updates
      // The 2nd parameter is the destructured `MutationLifecycleApi`
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        dispatch(
          userDataStorageApi.util.updateQueryData('getRiskAnalisysAndActionYearsForLoggedInCustomer', id, (draft) => {
            Object.assign(draft, patch)
          })
        )
        try {
          await queryFulfilled();
        } catch {
          //on failure you can invalidate the corresponding cache tags to trigger a re-fetch:
          dispatch(userDataStorageApi.util.invalidateTags({ type: 'RiskAnalisysAndActionYears', id: 'CUDS' }))
        }
      },
      // The 2nd parameter is the destructured `MutationCacheLifecycleApi`
      async onCacheEntryAdded(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          cacheEntryRemoved,
          cacheDataLoaded,
          getCacheEntry,
        }
      ) {},
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRiskAnalisysAndActionYearsForLoggedInCustomerQuery, useLazyGetRiskAnalisysAndActionYearsForLoggedInCustomerQuery, useUpdateRiskAnalisysAndActionYearsForLoggedInCustomerMutation, usePrefetch } = userDataStorageApi
export default userDataStorageApi;